import { render, staticRenderFns } from "./addAutoAnswer.vue?vue&type=template&id=46780f72&scoped=true&"
import script from "./addAutoAnswer.vue?vue&type=script&lang=js&"
export * from "./addAutoAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46780f72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46780f72')) {
      api.createRecord('46780f72', component.options)
    } else {
      api.reload('46780f72', component.options)
    }
    module.hot.accept("./addAutoAnswer.vue?vue&type=template&id=46780f72&scoped=true&", function () {
      api.rerender('46780f72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerService/components/addAutoAnswer.vue"
export default component.exports